<script>
  import {mapGetters, mapActions} from 'vuex'
  import {merge, isEmpty} from 'lodash'
  import bus from '@utils/bus'
  import * as restfulService from '../../services/restfulService'

  export default {
    name: 'list-main',
    props: {
      isPaginationVisible: {default: true}
    },
    data () {
      return {
        currentPage: 1
      }
    },
    computed: {
      ...mapGetters(['listStore']),
      pages: function () {
        let pages = [20, 50, 100, 500, this.listStore.listTotal]
        return pages.filter(item => item <= this.listStore.listTotal)
      }
    },
    methods: {
      ...mapActions(['setListStoreClear', 'setListInit', 'setListOriginalData', 'setListData', 'setListFilters', 'setListCurrentPage', 'setListPerPage', 'setListTotal']),
      onListInit (obj, callback) {
        bus.$emit('show-loader')
        this.onSearchRequest(obj, true, (response) => {
          this.setListInit({init: obj, data: response}).then(() => {
            if (typeof callback === 'function') {
              bus.$emit('hide-loader')
              callback(response)
            }
          })
        })
      },
      onSearchRequest (obj, first, callback) {
        bus.$emit('show-loader')
        let searchObj = this.listStore.init
        if (!first) {
          searchObj = merge({}, searchObj, obj)
        } else {
          searchObj = obj
        }
        searchObj.customSearch = searchObj.customSearch || false
        restfulService.search(searchObj.domain, searchObj.route, searchObj.data, searchObj.columns, searchObj.relations, searchObj.page, searchObj.perPage, searchObj.customSearch)
          .then((response) => {
            let list = []
            if (response !== null && response !== undefined && typeof response === 'object') {
              if (!response.data) {
                list = response
                this.setListTotal(response.length)
                this.setListPerPage(response.length)
              } else {
                list = response.data
                this.setListTotal(response.total)
              }
            }
            if (list.length > 0) {
              if (typeof obj.processResponse === 'function') {
                list = obj.processResponse(list)
              }
            }
            if (typeof callback === 'function') {
              callback(list)
              setTimeout(() => {
                bus.$emit('hide-loader')
              }, 400)
            }
          })
          .catch((err) => {
            bus.$emit('hide-loader')
            console.log('erro na listagem', err)
          })
      },
      onUpdateListData (list, callback) {
        this.onFilter(null, list, (newList) => {
          this.setListData(newList)
          if (typeof callback === 'function') {
            callback()
          }
        })
      },
      onFilter (filters, data, callback) {
        filters = filters || this.listStore.listFilters
        this.setListFilters(filters)
        let searchObj = this.listStore.init
        searchObj.data = data || {}
        this.onSearchRequest(searchObj, false, (response) => {
          this.setListData(response)
          if (typeof callback === 'function') {
            callback()
          }
        })
      },
      onFilterClean (filters, data, callback) {
        this.setListFilters(filters || {})
        this.setListCurrentPage(1)
        let searchObj = this.listStore.init
        if (isEmpty(data)) {
          delete searchObj.data
        } else {
          searchObj.data = data
        }
        this.onSearchRequest(searchObj, false, (response) => {
          this.setListData(response)
          if (typeof callback === 'function') {
            callback()
          }
        })
      },
      onDestroyItem (item, callback) {
        const id = item.id
        restfulService.destroy(this.listStore.init.domain, null, id)
          .then(() => {
            this.setListOriginalData(this.listStore.listOriginalData.filter(obj => obj.id !== id))
            this.onPaginatorChangePage(this.listStore.listCurrentPage)
            bus.$emit('hide-loader')
            if (typeof callback === 'function') {
              callback()
            }
          })
          .catch(e => {
            console.log(e)
            bus.$emit('hide-loader')
            if (typeof callback === 'function') {
              callback()
            }
          })
      },
      onPaginatorChangeSize (val) {
        this.setListPerPage(val)
        this.onPaginatorChangePage(1, val)
      },
      onPaginatorChangePage (page, perPage) {
        this.setListCurrentPage(page)
        this.currentPage = page
        let searchObj = this.listStore.init
        if (page && page !== undefined && page !== null && page > 0) {
          searchObj.page = page
        }
        if (perPage && perPage !== undefined && perPage !== null && perPage > 0) {
          searchObj.perPage = perPage
        }
        this.onSearchRequest(searchObj, false, (response) => {
          this.setListData(response)
        })
      }
    },
    mounted () {
      bus.$on('list-init', (obj, callback) => this.onListInit(obj, callback))
      bus.$on('list-data-update', (list, callback) => this.onUpdateListData(list, callback))
      bus.$on('list-filter', (filters, data, callback) => this.onFilter(filters, data, callback))
      bus.$on('list-filter-clean', (filters, data, callback) => this.onFilterClean(filters, data, callback))
      bus.$on('list-destroy-item', (item, callback) => this.onDestroyItem(item, callback))
    },
    beforeDestroy () {
      bus.$off('list-init')
      bus.$off('list-data-update')
      bus.$off('list-filter')
      bus.$off('list-filter-clean')
      bus.$off('list-destroy-item')
    }
  }
</script>

<template>
    <div class="list-component">

        <slot name="filters"></slot>

        <div class="main-list">
            <slot name="list"></slot>
        </div>

        <div class="footer">
            <span></span>
            <span>Total de Registros: <strong>{{listStore.listTotal}}</strong></span>
        </div>

        <el-pagination
                class="list-pagination"
                v-if="isPaginationVisible"
                :page-sizes="pages"
                :page-size="listStore.listPerPage"
                @size-change="onPaginatorChangeSize"
                @current-change="onPaginatorChangePage"
                :current-page.sync="currentPage"
                layout="sizes, prev, pager, next"
                :total="listStore.listTotal">
        </el-pagination>
    </div>
</template>



// WEBPACK FOOTER //
// Main.vue?2da036ea